"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import React, { useState, useEffect } from "react";
import { I18nProvider } from "./I18nProvider";
import { MsalTokenRegistration } from "@/auth/MsalProviderWrapper";
import { isMsalConfigured } from "@/auth/msalConfig";

function ToastProviders() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  if (!mounted) return null;
  return (
    <>
      <Toaster />
      <Sonner />
    </>
  );
}

function TooltipProviderClient({ children }: { children: React.ReactNode }) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  if (!mounted) return <>{children}</>;
  return <TooltipProvider>{children}</TooltipProvider>;
}

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <I18nProvider>
          {isMsalConfigured && <MsalTokenRegistration />}
          <TooltipProviderClient>
            <ToastProviders />
            {children}
          </TooltipProviderClient>
        </I18nProvider>
      </QueryClientProvider>
    </React.StrictMode>
  );
}
